import { useQuery, useMutation } from "react-query";
import axios from "../../axiosConfig/axios";

const getUser = async (token) => {
    const { data } = await axios.get('user',{
        headers: {
            Authorization: token
        }
    })
    return data
}
const addUpdateUsers = async (bodyData,update = false) => {
    let body = {
        users: bodyData.users
    }
    if(bodyData.companyId){
        body.companyId = bodyData.companyId
    }
    if(!update){
        const {data} = await axios.post('users',body,{
            headers: {
                Authorization: bodyData.token
            }
        })
        return data
    }else{
        const { data } = await axios.patch('users',body,{
            headers: {
                Authorization: bodyData.token
            }
        })
        return data
    }
}
export default {
    useData(token) { 
        return useQuery(["userdata",token], () => getUser(token),{staleTime: 10000})
    },
    useNewUsers() {
        return useMutation((data) => {
            return addUpdateUsers(data)
        })
    },
    useUpdateUsers() {
        return useMutation((data) => {
            return addUpdateUsers(data,true)
        })
    }
}